import React from 'react';
import Highlighter from 'react-highlight-words';
import { Icon, Space, Input, Button } from '@components';

const TableSearch = (dataIndex, name, { st1: searchText, st2: searchedColumn, setSt1: setSearchText, setSt2: setSearchedColumn }) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        autoFocus
        ref={(node) => {}}
        placeholder={`Buscar ${name}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleFilterSearch(selectedKeys, confirm, dataIndex, { setSearchText, setSearchedColumn })}
        style={{ width: 188, marginBottom: 8, display: 'flex' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => handleFilterSearch(selectedKeys, confirm, dataIndex, { setSearchText, setSearchedColumn })}
          icon={<Icon.SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button onClick={() => handleReset(clearFilters, { setSearchText })} size="small" style={{ width: 90 }}>
          Redefinir
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => <Icon.SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: (visible) => {},
  render: (text) =>
    searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

const handleFilterSearch = (selectedKeys, confirm, dataIndex, { setSearchText, setSearchedColumn }) => {
  confirm();
  setSearchText(selectedKeys[0]);
  setSearchedColumn(dataIndex);
};

const handleReset = (clearFilters, { setSearchText }) => {
  clearFilters();
  setSearchText('');
};

export default TableSearch;
